export default __webpack_public_path__ + "static/media/back-to-top-arrow.7ea7e715.svg";